// context/PlanoAlimentarContext.tsx
import React, { createContext, useContext, useState } from 'react';

interface PlanoAlimentarContextType {
  planoAlimentar: PlanoAlimentar | null;
  setPlanoAlimentar: (plano: PlanoAlimentar | null) => void;
  showAddAlimentoModal: boolean;
  setShowAddAlimentoModal: (show: boolean) => void;
  selectedOption: string | null;
  setSelectedOption: (option: string | null) => void;
  quantitative: boolean;
  setQuantitative: (quantitative: boolean) => void;
}

const PlanoAlimentarContext = createContext<PlanoAlimentarContextType | undefined>(undefined);

export const PlanoAlimentarProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [planoAlimentar, setPlanoAlimentar] = useState<PlanoAlimentar | null>(null);
  const [showAddAlimentoModal, setShowAddAlimentoModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState<string | null>(null);
  const [quantitative, setQuantitative] = useState<boolean>(true);

  return (
    <PlanoAlimentarContext.Provider value={{ planoAlimentar, setPlanoAlimentar, showAddAlimentoModal, setShowAddAlimentoModal, selectedOption, setSelectedOption, quantitative, setQuantitative }}>
      {children}
    </PlanoAlimentarContext.Provider>
  );
};

export const usePlanoAlimentar = (): PlanoAlimentarContextType => {
  const context = useContext(PlanoAlimentarContext);
  if (!context) throw new Error('usePlanoAlimentar deve estar dentro do PlanoAlimentarProvider');
  return context;
};
